<template>
    <nav
        class="sidebar-container n-h-1"
        :class="{ 'n-active': showMenu, 'is-collapsed': isCollapsed }"
        @click="$emit('toggle-menu')">
        <!-- Desktop collapse/expand button (Figma: Group 1312320353) -->
        <button
            v-if="!isSmallScreen"
            type="button"
            class="sidebar-collapse-btn"
            :class="{ 'is-collapsed': isCollapsed }"
            @click.stop="toggleCollapsed"
            aria-label="Toggle sidebar">
            <img
                src="@/assets/images/sidebar/sidebar-toggle.png"
                alt=""
                class="sidebar-collapse-icon" />
        </button>
        <div
            class="sidebar-container-inner n-border-box n-p-4 n-flex n-flex-dr-c n-h-1"
            @click.stop="() => {}">
            <a
                href="/chat"
                class="logo-container n-flex-s n-flex n-flex-a-c n-c-4"
                v-if="!isSmallScreen"
                @click.prevent="navigateTo('/chat')">
                <img
                    src="@/assets/images/logo.png"
                    class="n-block logo-img"
                    alt="Sovi.AI logo" />

                <img
                    src="@/assets/logot.png"
                    class="n-block n-ml-2 logo-text"
                    alt="Sovi.AI logo"
                    style="width: 4.28rem" />
            </a>

            <div class="login-container n-flex n-flex-a-c n-flex-j-e n-flex-s">
                <close-button
                    class="n-flex-s"
                    @click="$emit('toggle-menu')"
                    v-if="isSmallScreen" />
            </div>

            <div class="n-flex-g sidebar-nav-scroll n-scroll-y">
                <template
                    v-for="(group, groupIndex) in menuGroups"
                    :key="group.code">
                    <ul
                        class="nav-container"
                        :class="{ 'n-ptb-1': groupIndex > 0 }">
                        <template
                            v-for="menu in group.menus"
                            :key="menu.id">
                            <li
                                v-if="!menu.requireAuth || isLoggedIn"
                                class="nav-item"
                                :class="{ 'nav-open': menu.children && menu.children.length > 0 }">
                                <!-- 集成 + 当前窗口: SPA内路由，不刷新页面 -->
                                <a
                                    v-if="(menu.linkType === 1 || menu.openMode === 3) && menu.openMode !== 2"
                                    :href="menu.path || 'javascript:void(0)'"
                                    class="nav-link n-border-box n-block n-col-1"
                                    :class="{ 'n-active': isMenuActive(menu) }"
                                    @click.prevent="
                                        navigateTo(menu.path);
                                        handleNavOpen(menu.path);
                                    ">
                                    <div class="nav-inner n-border-box n-col-1 n-h-1 n-flex n-flex-a-c">
                                        <blog-icon
                                            v-if="menu.icon === 'blog'"
                                            :size="20"
                                            class="n-flex-s nav-icon" />
                                        <nicon
                                            v-else-if="menu.icon"
                                            :icon="menu.icon"
                                            :size="getIconSize(menu.icon)"
                                            class="n-flex-s nav-icon" />
                                        <span class="nav-text n-inline-block n-f-3 n-c-4 n-flex-g">{{ menuName(menu) }}</span>
                                        <span
                                            v-if="menu.tag"
                                            class="nav-tag">
                                            {{ menu.tag }}
                                        </span>
                                    </div>
                                </a>

                                <!-- 集成/独立 + 新Tab 或 独立 + 当前窗口: 浏览器级导航 -->
                                <a
                                    v-else
                                    :href="menu.path || 'javascript:void(0)'"
                                    :target="menu.path && menu.openMode === 2 ? '_blank' : '_self'"
                                    :rel="menu.path && menu.openMode === 2 ? 'noopener noreferrer' : undefined"
                                    class="nav-link n-border-box n-block n-col-1"
                                    @click="!menu.path && $event.preventDefault()">
                                    <div class="nav-inner n-border-box n-col-1 n-h-1 n-flex n-flex-a-c">
                                        <blog-icon
                                            v-if="menu.icon === 'blog'"
                                            :size="20"
                                            class="n-flex-s nav-icon" />
                                        <nicon
                                            v-else-if="menu.icon"
                                            :icon="menu.icon"
                                            :size="getIconSize(menu.icon)"
                                            class="n-flex-s nav-icon" />
                                        <span class="nav-text n-inline-block n-f-3 n-c-4 n-flex-g">{{ menuName(menu) }}</span>
                                        <span
                                            v-if="menu.tag"
                                            class="nav-tag">
                                            {{ menu.tag }}
                                        </span>
                                    </div>
                                </a>

                                <!-- Sub-menu -->
                                <ul
                                    v-if="menu.children && menu.children.length > 0"
                                    class="sub-nav-container">
                                    <li
                                        v-for="child in menu.children"
                                        :key="child.id"
                                        class="sub-nav-item"
                                        v-show="!child.requireAuth || isLoggedIn">
                                        <!-- 集成 + 当前窗口 -->
                                        <a
                                            v-if="(child.linkType === 1 || child.openMode === 3) && child.openMode !== 2"
                                            :href="child.path || 'javascript:void(0)'"
                                            class="sub-nav-link n-border-box n-block n-col-1"
                                            :class="{ 'n-active': isMenuActive(child) }"
                                            @click.prevent="navigateTo(child.path)">
                                            <div class="sub-nav-inner n-border-box n-col-1 n-h-1 n-flex n-flex-a-c">
                                                <blog-icon
                                                    v-if="child.icon === 'blog'"
                                                    :size="18"
                                                    class="n-flex-s nav-icon" />
                                                <nicon
                                                    v-else-if="child.icon"
                                                    :icon="child.icon"
                                                    :size="18"
                                                    class="n-flex-s nav-icon" />
                                                <span class="nav-text n-inline-block n-f-3 n-c-4 n-flex-g">{{ menuName(child) }}</span>
                                            </div>
                                        </a>
                                        <!-- 其他: 浏览器级导航 -->
                                        <a
                                            v-else
                                            :href="child.path || 'javascript:void(0)'"
                                            :target="child.path && child.openMode === 2 ? '_blank' : '_self'"
                                            :rel="child.path && child.openMode === 2 ? 'noopener noreferrer' : undefined"
                                            class="sub-nav-link n-border-box n-block n-col-1"
                                            :class="{ 'n-active': isMenuActive(child) }"
                                            @click="!child.path && $event.preventDefault()">
                                            <div class="sub-nav-inner n-border-box n-col-1 n-h-1 n-flex n-flex-a-c">
                                                <blog-icon
                                                    v-if="child.icon === 'blog'"
                                                    :size="18"
                                                    class="n-flex-s nav-icon" />
                                                <nicon
                                                    v-else-if="child.icon"
                                                    :icon="child.icon"
                                                    :size="18"
                                                    class="n-flex-s nav-icon" />
                                                <span class="nav-text n-inline-block n-f-3 n-c-4 n-flex-g">{{ menuName(child) }}</span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                        </template>
                    </ul>
                    <nline
                        v-if="groupIndex < menuGroups.length - 1"
                        :margin="4" />
                </template>
            </div>

            <div class="n-flex-s n-mt-6">
                <div
                    class="nav-svip n-flex n-flex-a-c n-radius-10 n-ptb-1 n-plr-2"
                    v-if="userInfo?.subscriptions?.subscribed">
                    <img
                        src="@/assets/images/svip/vipact.png"
                        alt="svip"
                        class="nav-svip-icon n-flex-s n-mr-2" />

                    <div class="n-flex n-flex-a-c">
                        <span class="n-f-3 n-f-bold7 n-c-base n-mr-1">{{ $t('APPShortName') }}</span>
                        <span class="c-svip-plus"></span>
                    </div>
                </div>

                <!-- 非会员卡片：合并 nav-upgrade + nav-sparks 功能 -->
                <div
                    class="nav-vip-card"
                    v-else>
                    <!-- 顶部：Sparks 标签 + 剩余次数（仅登录后展示） -->
                    <template v-if="isLoggedIn && !userInfo?.subscriptions?.subscribed">
                        <div
                            class="nav-vip-card-header"
                            :class="{ 'is-zero': isSparksZero }">
                            <div class="nav-vip-card-title">
                                <span class="nav-vip-card-title-text">Sparks</span>
                                <svg
                                    class="nav-vip-card-title-plus"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 30 30"
                                    fill="none">
                                    <path
                                        d="M16.594 4.15092C16.1977 2.61502 14.0166 2.61502 13.6203 4.15092L12.0962 10.0578C12.0078 10.4927 11.8853 10.9558 11.7441 11.4222C11.7336 11.4621 11.7216 11.5014 11.7081 11.54C11.3404 12.5873 10.9996 13.4987 10.4996 14.4986C10.9996 13.4987 10.9996 12.9987 10.9996 12.4987L4.9993 14.214C3.79513 14.7583 3.79513 16.4683 4.9993 17.0126L11.2418 18.924C11.6658 19.1156 11.98 19.4891 12.0962 19.9396L14.007 27.3603C14.4033 28.8962 16.5844 28.8962 16.9807 27.3603L18.5048 21.4534C18.5932 21.0185 18.7157 20.5554 18.8569 20.089C18.8674 20.0491 18.8794 20.0098 18.8929 19.9712C19.2606 18.924 19.6014 18.0126 20.1014 17.0126C19.6014 18.0126 19.6014 18.5125 19.6014 19.0125L25.4988 17.0126C26.703 16.4683 26.703 14.7583 25.4988 14.214L19.3592 12.5873C18.9352 12.3956 18.621 12.0221 18.5048 11.5716L16.594 4.15092Z"
                                        fill="#8C55F2" />
                                </svg>
                            </div>
                            <span class="nav-vip-card-count">{{ webSparks }}</span>
                        </div>
                        <div class="nav-vip-card-divider"></div>
                        <div class="nav-vip-card-info">
                            <span class="nav-vip-card-info-icon">
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none">
                                    <circle
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        fill="#F2EAFF" />
                                    <path
                                        d="M8 12.5L11 15.5L16 9.5"
                                        stroke="#8C55F2"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </span>
                            <span class="nav-vip-card-info-text">{{ $t('profile.sparksReset') }}</span>
                        </div>
                    </template>

                    <!-- 底部：升级按钮 -->
                    <div
                        class="nav-upgrade n-flex n-flex-a-c n-flex-j-c n-radius-10 n-pointer"
                        :class="{ 'nav-upgrade-standalone': !isLoggedIn || userInfo?.subscriptions?.subscribed }"
                        @click="goSvip">
                        <img
                            src="@/assets/images/svip/vipngt.png"
                            alt="svip"
                            class="nav-svip-icon n-flex-s n-mr-2" />
                        <span class="n-f-3 n-f-bold7 n-c-white">{{ $t('profile.upgrateNow') }}</span>
                        <svg
                            width="12"
                            height="12"
                            viewBox="0 0 23 23"
                            fill="none"
                            class="n-flex-s n-ml-2 nav-upgrade-arrow">
                            <path
                                d="M17.5016 12.9375H0V10.0625H17.5016L9.45156 2.0125L11.5 0L23 11.5L11.5 23L9.45156 20.9875L17.5016 12.9375Z"
                                fill="#fff" />
                        </svg>
                    </div>
                </div>

                <nline
                    :margin="10"
                    class="nav-upgrade-divider" />

                <el-popover
                    placement="bottom-end"
                    width="auto"
                    trigger="click"
                    popper-class="user-info-popover"
                    ref="userPopover"
                    v-if="isLoggedIn">
                    <template #reference>
                        <div
                            class="n-flex n-flex-a-c n-pointer c-hover"
                            @click="handleUserClick">
                            <div class="nav-user-avatar n-c-1 n-f-5 n-bg-base n-radius-circle n-flex n-flex-a-c n-flex-j-c n-f-bold5 n-line-height-1 n-flex-s n-mr-2">
                                {{ ((userInfo?.nickName ? userInfo?.nickName : userInfo?.email) || '').substring(0, 1).toUpperCase() }}
                            </div>

                            <span class="nav-user-name n-f-3 n-f-bold7 n-c-4 n-flex-g n-flex-g-w-1-hack n-e-1">
                                {{ userInfo?.nickName ? userInfo?.nickName : userInfo?.email }}
                            </span>

                            <nicon
                                icon="list-arrow-right"
                                size="15"
                                class="n-flex-s n-c-4 nav-arrow" />
                        </div>
                    </template>

                    <user-info-box @close="userPopover.hide()"></user-info-box>
                </el-popover>

                <div
                    class="n-flex n-flex-a-c n-pointer c-hover"
                    @click="handleUserClick"
                    v-else>
                    <div
                        class="nav-user-avatar n-c-1 n-f-5 n-radius-circle n-flex n-flex-a-c n-flex-j-c n-f-bold5 n-line-height-1 n-flex-s n-mr-2"
                        style="background-color: #ccc">
                        <nicon
                            icon="user"
                            size="25"
                            class="n-flex-s n-c-1 nav-arrow" />
                    </div>

                    <span class="nav-user-name n-f-3 n-f-bold7 n-c-4 n-flex-g n-flex-g-w-1-hack n-e-1">
                        {{ $t('login.login') }}
                    </span>

                    <nicon
                        icon="list-arrow-right"
                        size="15"
                        class="n-flex-s n-c-4 nav-arrow" />
                </div>
            </div>
        </div>
    </nav>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { logEvent } from '@/utils/utils.ts';
import { EVENT_TYPES, globalEmit } from '@/utils/eventBus';
import { checkAuth } from '@/utils/authCheck';

import UserInfoBox from '@/components/business/user/user-info-box.vue';
import BlogIcon from '@/components/common/nicon/blog-icon.vue';

const userPopover = ref();

// Props
defineProps<{
    showMenu: boolean;
}>();

// Emits
defineEmits<{
    'toggle-menu': [];
}>();

const store = useStore();
const route = useRoute();
const router = useRouter();
const isSmallScreen = computed(() => store.getters['viewport/isSmallScreen']);
const isCollapsed = ref(false);

const toggleCollapsed = () => {
    isCollapsed.value = !isCollapsed.value;
};

// Avoid collapsed state on small screens (small screens already use overlay menu)
watch(isSmallScreen, val => {
    if (val) isCollapsed.value = false;
});

// Getters
const { t, te } = useI18n();

// 菜单名多语言：后端返回的 name 为英文源。用 name 去空格 + 转小写作为 i18n key
// (sidebarMenu.<slug>)——id 在生产环境不稳定，故不用 id。无对应 key 的菜单（如
// 后台新增项）优雅降级回后端 name。
const menuName = (menu: { name: string }): string => {
    const slug = (menu.name || '').replace(/\s+/g, '').toLowerCase();
    const key = `sidebarMenu.${slug}`;
    return te(key, 'en') ? t(key) : menu.name;
};
const userInfo = computed(() => store.getters['user/userInfo']);
const isLoggedIn = computed(() => store.getters['user/isLoggedIn']);
const webSparks = computed(() => store.getters['user/webSparks']);
// Sparks 余额为 0：图标 / 数字 /「Sparks」文案统一置灰
const isSparksZero = computed(() => Number(webSparks.value) === 0);
const menuGroups = computed(() => {
    const groups = store.getters['menu/groups'];
    if (!groups || groups.length === 0) return groups;
    
    // Deep clone to avoid mutating store state directly
    const newGroups = JSON.parse(JSON.stringify(groups)) as any[];
    const coreGroup = newGroups.find(g => g.code === 'core') || newGroups[0];
    if (coreGroup) {
        const hasHome = coreGroup.menus.some((m: any) => m.path === '/home');
        if (!hasHome) {
            coreGroup.menus.unshift({
                id: 15,
                name: 'Home',
                icon: 'home',
                path: '/home',
                linkType: 1,
                openMode: 1,
                externalUrl: '',
                tag: '',
                requireAuth: false,
                children: []
            });
        }
    }
    return newGroups;
});

// Icon size overrides to match original hardcoded sidebar
const iconSizeMap: Record<string, number> = {
    study: 15
};
const getIconSize = (icon: string) => iconSizeMap[icon] || 20;

// Chat 菜单激活状态
const isChatActive = computed(() => route.name === 'chat');
const isVideoActive = computed(() => route.name === 'video');

// Study 菜单激活状态
const isStudyActive = computed(() => route.name === 'study' && !route.query.type);
const isKnowledgeActive = computed(() => route.name === 'study' && route.query.type == 'knowledge');
const isQuizActive = computed(() => route.name === 'study' && route.query.type == 'quiz');
const isTestPrepActive = computed(() => ['exam-home', 'testprep', 'check', 'generate', 'exam', 'testprep-result', 'apexam', 'apexam-practice', 'apexam-exam', 'apexam-result'].includes(String(route.name || '')));
const isBlogActive = computed(() => route.path.startsWith('/blog'));
const navOpenKey = ref('');

// 监听路由变化，关闭 popover
watch(
    () => route.path,
    () => {
        if (userPopover.value) {
            userPopover.value.hide();
        }
    }
);

onMounted(() => {
    const routeName = route.name;

    // 如果是chat子页面，则打开导航
    if (routeName === 'video') {
        navOpenKey.value = 'chat';
    }

    // 如果是study子页面，则打开导航
    if (routeName === 'study' && route.query.type) {
        navOpenKey.value = 'study';
    }
});

const handleNavOpen = (key: string) => {
    if (navOpenKey.value === key) {
        navOpenKey.value = '';
    } else {
        navOpenKey.value = key;
    }
};

const navigateTo = (path: string) => {
    if (!path) return;
    if (route.fullPath === path) return;
    // Menu paths come from the backend and may point at pages that are NOT SPA
    // routes (e.g. /about and /faq, now static SEO pages). router.push() to an
    // unmatched path leaves the router-view empty — a white screen. Fall back to
    // a full-page load so the server resolves it (static file / 308 redirect).
    if (!router.resolve(path).matched.length) {
        window.location.assign(path);
        return;
    }
    router.push(path);
};

const isMenuActive = (menu: any): boolean => {
    const menuPath = menu.path;
    // Exact match for paths with query params (e.g. /study?type=knowledge)
    if (menuPath.includes('?')) {
        return route.fullPath === menuPath;
    }
    // Prefix match for base paths
    return route.path === menuPath || route.path.startsWith(menuPath + '/');
};

/**
 * 打开会员订阅页
 */
const goSvip = () => {
    if (!checkAuth({ redirectType: 'chat' })) {
        return; // 未登录，已自动打开登录框，直接返回
    }

    logEvent('web_mine_vip_click', {
        trigger_scene: 'sidebar'
    });

    router.push({ name: 'svip', query: { page_source: 'mine', page_stage: 'proactive_paywall' } });
};

const handleUserClick = () => {
    if (isLoggedIn.value) {
        logEvent('web_profile_click');
    } else {
        globalEmit(EVENT_TYPES.GO_LOGIN, {
            type: router.currentRoute.value.name
        });
    }
};
</script>

<style scoped lang="scss">
.logo-container {
    padding: 8px 12px;
    margin-bottom: 20px;
    text-decoration: none;

    .logo-img {
        width: 32px;
        height: 32px;
    }

    .logo-text {
        font-size: 20px;
        margin-left: 9px;
    }
}

.sidebar-container {
    width: 290px;
    background: var(--menu-background-color);
    position: relative;
    z-index: 100;
    border-right: 1px solid var(--menu-border-color);
    transition: width 0.25s ease;
    overflow: visible; // allow collapse button to sit on border line

    &.is-collapsed {
        // collapsed rail (icons only)
        width: 88px;
    }

    .sidebar-container-inner {
        transition:
            transform 0.25s ease,
            opacity 0.25s ease;
        transform: translateX(0);
        opacity: 1;
    }

    // In collapsed mode we keep inner visible (but hide texts)
    &.is-collapsed .sidebar-container-inner {
        transform: translateX(0);
        opacity: 1;
        pointer-events: auto;
        padding-left: 8px !important;
        padding-right: 8px !important;
    }

    .sidebar-collapse-btn {
        position: absolute;
        top: 28px;
        right: 0;
        transform: translateX(50%);
        width: 32px;
        height: 32px;
        background: transparent;
        cursor: pointer;
        z-index: 200;
        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
        border-radius: 50%;
        border: 2px solid #e5e5e5;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        .sidebar-collapse-icon {
            width: 15px;
            display: block;
            margin-top: -1px;
            transform: rotate(180deg);
        }

        &:hover .sidebar-collapse-icon {
            animation: arrowNudgeLeft 1s ease-in-out infinite;
        }

        &.is-collapsed {
            .sidebar-collapse-icon {
                transform: rotate(0deg);
            }

            &:hover .sidebar-collapse-icon {
                animation: arrowNudgeRight 1s ease-in-out infinite;
            }
        }
    }

    @keyframes arrowNudgeLeft {
        0%,
        100% {
            transform: rotate(180deg) translateX(0);
        }
        50% {
            transform: rotate(180deg) translateX(3px);
        }
    }

    @keyframes arrowNudgeRight {
        0%,
        100% {
            transform: rotate(0deg) translateX(0);
        }
        50% {
            transform: rotate(0deg) translateX(3px);
        }
    }

    // --- collapsed (icons-only) layout tweaks ---
    &.is-collapsed {
        .logo-container {
            justify-content: center;
            padding: 8px 0;
        }

        .logo-text {
            display: none;
        }

        .nav-arrow-container,
        .nav-text-coming-soon,
        .nav-tag,
        .sub-nav-container,
        .nav-user-name {
            display: none !important;
        }

        // 折叠态隐藏会员皇冠 / 非会员卡片 / 升级按钮的分割线
        .nav-svip,
        .nav-vip-card,
        .nav-upgrade-divider {
            display: none !important;
        }

        .nav-container {
            .nav-link,
            .sub-nav-link {
                .nav-inner,
                .sub-nav-inner {
                    padding: 6px 0;
                    justify-content: center;
                    flex-direction: column;
                    align-items: center;
                    min-height: auto;
                }

                .nav-icon {
                    margin: 0;
                }

                .nav-text {
                    display: block !important;
                    margin-left: 0;
                    margin-top: 4px;
                    font-size: 12px;
                    font-weight: 500;
                    text-align: center;
                    line-height: 1.2;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 100%;
                }
            }
        }

        // bottom user section: keep avatar centered
        .n-flex-s.n-mt-6 {
            justify-content: center;
        }

        .n-flex-s.n-mt-6 > .n-flex.n-flex-a-c {
            width: 100%;
            justify-content: center;
        }

        .nav-user-avatar {
            margin-right: 0 !important;
        }
    }

    .nav-container {
        .nav-link,
        .sub-nav-link {
            position: relative;
            text-decoration: none;

            .nav-text-coming-soon {
                position: absolute;
                left: 170px;
                top: 9px;
                display: flex;
                align-items: center;
                background-color: var(--color-red);
                color: #fff;
                font-size: 8px;
                height: 14px;
                font-weight: 500;
                padding: 0 6px;
                border-radius: 3px 3px 3px 0;
            }

            .nav-tag {
                display: inline-flex;
                align-items: center;
                padding: 1.3px 5px;
                height: 16px;
                background: #f43530;
                color: #fff;
                font-size: 10px;
                font-weight: 600;
                border-radius: 4px 4px 7.916px 0;
                left: 147px;
                position: absolute;
                top: -3px;
            }

            .nav-inner,
            .sub-nav-inner {
                min-height: 44px;
                border-radius: 10px;
                background-color: rgba(0, 0, 0, 0);
                transition: all 0.3s;
                padding: 0 15px;
                box-sizing: border-box;
            }

            .nav-arrow {
                transition: transform 0.3s;
            }

            .nav-icon {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                color: var(--font-color-4);
                transition: transform 0.3s;
            }

            &:active .nav-icon {
                animation: icon-bounce 0.35s ease;
            }

            @keyframes icon-bounce {
                0% {
                    transform: scale(1);
                }
                30% {
                    transform: scale(0.88);
                }
                60% {
                    transform: scale(1.05);
                }
                100% {
                    transform: scale(1);
                }
            }

            .nav-text {
                margin-left: 8px;
                font-weight: 600;
                transition: all 0.3s;
            }

            &:active .nav-text {
                transform: scale(0.95);
            }

            &:hover {
                .nav-text,
                .nav-icon,
                .nav-arrow {
                    color: var(--color-base);
                }

                .nav-inner,
                .sub-nav-inner {
                    background-color: #f3f4f6;
                }
            }

            &.n-active {
                .nav-icon,
                .nav-arrow,
                .nav-text {
                    color: var(--color-base);
                }

                .nav-inner,
                .sub-nav-inner {
                    background-color: var(--menu-active-bg-color);
                }

                .nav-text {
                    font-weight: 700;
                }
            }
        }

        .sub-nav-container {
            max-height: 0;
            overflow: hidden;

            .sub-nav-item {
                .sub-nav-link {
                    .sub-nav-inner {
                        padding-left: 35px;
                        min-height: 44px;
                    }

                    .nav-text {
                        font-size: 0.94em;
                    }
                }
            }
        }

        .nav-item {
            margin-bottom: 10px;

            &:last-child {
                margin-bottom: 0;
            }

            &.nav-open {
                background-color: #fafbfd;
                border-radius: 10px;

                .nav-arrow {
                    transform: rotate(180deg);
                }

                .sub-nav-container {
                    max-height: 999px;
                }
            }
        }
    }
}

.nav-user-avatar {
    width: 46px;
    height: 46px;
}

.nav-svip-icon {
    width: 40px;
    height: 40px;
    object-fit: contain;
}

.nav-svip {
    border: 2px solid var(--color-base);

    &.is-loading {
        opacity: 0.7;
        cursor: wait;
    }
}

.nav-vip-card {
    width: 100%;
    background: #faf8ff;
    border-radius: 16px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.12);
    box-sizing: border-box;

    .nav-vip-card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 4px;
    }

    .nav-vip-card-title {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        color: var(--color-base);
    }

    .nav-vip-card-title-text {
        font-size: 14px;
        font-weight: 600;
        line-height: 1.2;
    }

    .nav-vip-card-title-plus {
        display: block;
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }

    .nav-vip-card-count {
        font-size: 14px;
        font-weight: 700;
        color: var(--color-base);
        line-height: 1.2;
    }

    // Sparks 余额为 0：图标 / 数字 /「Sparks」文案统一置灰
    .nav-vip-card-header.is-zero {
        .nav-vip-card-title {
            color: #8e8e93;
        }

        .nav-vip-card-title-plus {
            filter: grayscale(1);
            opacity: 0.5;
        }

        .nav-vip-card-count {
            color: #8e8e93;
        }
    }

    .nav-vip-card-divider {
        height: 1px;
        background: #e5e5e5;
        margin: 0 4px;
    }

    .nav-vip-card-info {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 0 4px;
    }

    .nav-vip-card-info-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .nav-vip-card-info-text {
        font-size: 12px;
        line-height: 1.3;
        color: #4a4454;
    }
}

.nav-upgrade {
    width: 100%;
    min-height: 40px;
    background: var(--color-base);
    padding: 8px 12px;
    box-sizing: border-box;
    transition:
        transform 0.2s ease,
        box-shadow 0.2s ease,
        filter 0.2s ease;

    .nav-svip-icon {
        width: 22px;
        height: 22px;
        margin-right: 8px;
    }

    .nav-upgrade-arrow {
        margin-left: 8px;
    }

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(18, 8, 37, 0.2);
        filter: brightness(1.05);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(18, 8, 37, 0.18);
        filter: brightness(1);
    }
}
</style>

<!-- 小屏幕样式 -->
<style lang="scss" scoped>
.small-screen {
    .sidebar-container {
        position: fixed;
        top: 0;
        left: -100vw;
        width: 100vw;
        height: 100vh;
        z-index: 100;
        transition: all 0.3s;
        background-color: transparent;
        border-right: 0 !important;

        .sidebar-container-inner {
            box-shadow: 5px 0px 10px 0px rgba(141, 141, 141, 0.2);
            background: var(--menu-background-color);
            width: calc(100vw - 20px);
            max-width: 300px;
        }

        &.n-active {
            left: 0;
        }
    }
}
</style>

<style lang="scss">
.user-info-popover {
    box-shadow: 0 10.516px 31.547px 10.516px rgba(18, 8, 37, 0.1) !important;
}
</style>
